import { selectorBusinessId, selectorCurrentUser } from "@/app/stores/auth/auth.selectors";
import { inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, Observable, take } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PermissionChecker {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly businessId$ = this.store.select(selectorBusinessId);
  readonly currentUser$ = this.store.select(selectorCurrentUser);

  currentRole$ = combineLatest([this.currentUser$, this.businessId$]).pipe(
    filter(([currentUser, businessId]) => !!currentUser && !!businessId),
    map(([currentUser, businessId]) => currentUser?.businessUsers?.find((businessUser) => businessUser.businessId === businessId)?.role)
  );

  hasRole(role: string | string[]): Observable<boolean> {
    const allowedRoles = Array.isArray(role) ? role : [role];
    return combineLatest([this.currentUser$, this.businessId$]).pipe(
      map(([currentUser, businessId]) => {
        // If user or businessId is not loaded yet, allow access (will be checked later)
        if (!currentUser || !businessId) {
          return true;
        }
        const currentRole = currentUser?.businessUsers?.find((businessUser) => businessUser.businessId === businessId)?.role;
        return !!currentRole && allowedRoles.includes(currentRole);
      }),
      // Take first emission to avoid hanging
      take(1)
    );
  }
}
